import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Modal } from '@lionstep/ui';

// Styles
import styles from './deleteJobModal.module.scss';

const DeleteJobModal = ({ show, onConfirm, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onClose={onClose}>
      <Modal.Header>{t('dashboard_page.modals.delete_job_title')}</Modal.Header>
      <Modal.Body className={styles.modalBody}>
        {t('delete_job_question')}
      </Modal.Body>
      <Modal.Footer
        closeText={t('cancel')}
        confirmText={t('delete')}
        confirmButtonType="danger"
        onConfirm={onConfirm}
        onClose={onClose}
      />
    </Modal>
  );
};

DeleteJobModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DeleteJobModal;
